<script>
import FooterView from '../../shared/views/MainFooterView';
import BrandLogo from '../../shared/BrandLogo.vue';
export default {
  name: 'SiteMapPageView',
  components: {
        'brand-logo': BrandLogo,
    'footer-view': FooterView,
  },
};
</script>

<template>
  <div class="public-page-wrapper">
    <!-- Header -->
    <header class="public-header">
      <div class="public-header__inner">
        <router-link to="/">
          <brand-logo variant="dark" />
        </router-link>
        <nav class="public-header__nav">
          <router-link to="/">Inicio</router-link>
          <router-link to="/acerca">Acerca</router-link>
          <router-link to="/cursos">Cursos</router-link>
          <router-link to="/noticias">Noticias</router-link>
          <router-link to="/contacto">Contacto</router-link>
        </nav>
        <div class="public-header__actions">
          <router-link
            to="/login"
            class="btn-outline"
          >
            Iniciar Sesión
          </router-link>
          <router-link
            to="/registrarse"
            class="btn-fill"
          >
            Registrarse
          </router-link>
        </div>
      </div>
    </header>

    <!-- Hero -->
    <section class="public-hero">
      <div class="public-hero__inner">
        <nav class="public-hero__nav">
          <router-link to="/">Inicio</router-link>
          <span>/</span>
          <a
            href="#"
            class="active"
          >Mapa del Sitio</a>
        </nav>
        <h1 class="public-hero__title">Mapa del Sitio</h1>
        <p class="public-hero__subtitle">Explora todas las secciones y páginas disponibles en AppMisionate.</p>
      </div>
    </section>

    <!-- Body -->
    <main class="public-body">
      <div class="row">
        <!-- Principal -->
        <div class="col-lg-6 col-md-6 mb-24">
          <div class="public-card sitemap-section">
            <div class="public-card__accent-bar" />
            <h3><i class="uil uil-home" /> Principal</h3>
            <ul class="sitemap-links">
              <li>
                <router-link to="/">
                  <i class="uil uil-arrow-right" /> Inicio
                </router-link>
              </li>
              <li>
                <router-link to="/acerca">
                  <i class="uil uil-arrow-right" /> Acerca de Nosotros
                </router-link>
              </li>
              <li>
                <router-link to="/contacto">
                  <i class="uil uil-arrow-right" /> Contacto
                </router-link>
              </li>
              <li>
                <router-link to="/soporte">
                  <i class="uil uil-arrow-right" /> Centro de Soporte
                </router-link>
              </li>
            </ul>
          </div>
        </div>

        <!-- Cursos -->
        <div class="col-lg-6 col-md-6 mb-24">
          <div class="public-card sitemap-section">
            <div class="public-card__accent-bar" />
            <h3><i class="uil uil-book-open" /> Aprendizaje</h3>
            <ul class="sitemap-links">
              <li>
                <router-link to="/cursos">
                  <i class="uil uil-arrow-right" /> Cursos Disponibles
                </router-link>
              </li>
              <li>
                <router-link to="/cursos">
                  <i class="uil uil-arrow-right" /> Simuladores Educativos
                </router-link>
              </li>
              <li>
                <router-link to="/cursos">
                  <i class="uil uil-arrow-right" /> Evaluaciones
                </router-link>
              </li>
              <li>
                <router-link to="/cursos">
                  <i class="uil uil-arrow-right" /> Certificados
                </router-link>
              </li>
            </ul>
          </div>
        </div>

        <!-- Blog y Noticias -->
        <div class="col-lg-6 col-md-6 mb-24">
          <div class="public-card sitemap-section">
            <div class="public-card__accent-bar" />
            <h3><i class="uil uil-newspaper" /> Blog y Noticias</h3>
            <ul class="sitemap-links">
              <li>
                <router-link to="/noticias">
                  <i class="uil uil-arrow-right" /> Publicaciones y Noticias
                </router-link>
              </li>
              <li>
                <router-link to="/noticias">
                  <i class="uil uil-arrow-right" /> Artículos Educativos
                </router-link>
              </li>
              <li>
                <router-link to="/noticias">
                  <i class="uil uil-arrow-right" /> Novedades de la Plataforma
                </router-link>
              </li>
            </ul>
          </div>
        </div>

        <!-- Legal -->
        <div class="col-lg-6 col-md-6 mb-24">
          <div class="public-card sitemap-section">
            <div class="public-card__accent-bar" />
            <h3><i class="uil uil-shield" /> Legal</h3>
            <ul class="sitemap-links">
              <li>
                <router-link to="/terminos-y-condiciones">
                  <i class="uil uil-arrow-right" /> Términos y Condiciones
                </router-link>
              </li>
              <li>
                <router-link to="/terminos-y-condiciones">
                  <i class="uil uil-arrow-right" /> Políticas de Privacidad
                </router-link>
              </li>
              <li>
                <router-link to="/terminos-y-condiciones">
                  <i class="uil uil-arrow-right" /> Políticas de Cookies
                </router-link>
              </li>
              <li>
                <router-link to="/terminos-y-condiciones">
                  <i class="uil uil-arrow-right" /> Derechos de Autor
                </router-link>
              </li>
            </ul>
          </div>
        </div>

        <!-- Cuenta -->
        <div class="col-lg-6 col-md-6 mb-24">
          <div class="public-card sitemap-section">
            <div class="public-card__accent-bar" />
            <h3><i class="uil uil-user" /> Mi Cuenta</h3>
            <ul class="sitemap-links">
              <li>
                <router-link to="/login">
                  <i class="uil uil-arrow-right" /> Iniciar Sesión
                </router-link>
              </li>
              <li>
                <router-link to="/registrarse">
                  <i class="uil uil-arrow-right" /> Crear Cuenta
                </router-link>
              </li>
              <li>
                <router-link to="/recuperar-contrasena">
                  <i class="uil uil-arrow-right" /> Recuperar Contraseña
                </router-link>
              </li>
              <li>
                <router-link to="/confirmar-cuenta">
                  <i class="uil uil-arrow-right" /> Confirmar Cuenta
                </router-link>
              </li>
            </ul>
          </div>
        </div>

        <!-- Recursos -->
        <div class="col-lg-6 col-md-6 mb-24">
          <div class="public-card sitemap-section">
            <div class="public-card__accent-bar" />
            <h3><i class="uil uil-bookmark" /> Recursos</h3>
            <ul class="sitemap-links">
              <li>
                <router-link to="/mapa-del-sitio">
                  <i class="uil uil-arrow-right" /> Mapa del Sitio
                </router-link>
              </li>
              <li>
                <router-link to="/soporte">
                  <i class="uil uil-arrow-right" /> Centro de Ayuda
                </router-link>
              </li>
              <li>
                <router-link to="/contacto">
                  <i class="uil uil-arrow-right" /> Formulario de Contacto
                </router-link>
              </li>
              <li>
                <router-link to="/terminos-y-condiciones">
                  <i class="uil uil-arrow-right" /> Términos de Asesor
                </router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </main>

    <footer-view />
  </div>
</template>

<style scoped>
.mb-24 {
  margin-bottom: 24px;
}

.sitemap-section {
  height: 100%;
}

.sitemap-section h3 {
  font-size: 1rem;
  font-weight: 700;
  color: #0f172a;
  margin: 0 0 16px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.sitemap-section h3 i {
  color: #0D47A1;
  font-size: 18px;
}

.sitemap-links {
  list-style: none;
  padding: 0;
  margin: 0;
}

.sitemap-links li {
  margin-bottom: 8px;
}

.sitemap-links li:last-child {
  margin-bottom: 0;
}

.sitemap-links a {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-family: 'Roboto', sans-serif;
  font-size: 0.9375rem;
  color: #475569;
  text-decoration: none;
  transition: all 0.2s ease;
}

.sitemap-links a i {
  color: #0D47A1;
  font-size: 14px;
  transition: transform 0.2s ease;
}

.sitemap-links a:hover {
  color: #0D47A1;
  font-weight: 500;
}

.sitemap-links a:hover i {
  transform: translateX(4px);
}
</style>
